import * as React from 'react';

import StayDates from './StayDates';
import HotelInfo from './HotelInfo';
import OccupantsInfo from './OccupantsInfo';
import RoomAndOfferInfo from './RoomAndOfferInfo';
import { Wrapper, MobileIcon, HorizontalRuleDesktop } from './primitives';
import { DetailsBooking } from 'types';

const BookingSummary: React.FC<{ booking: DetailsBooking }> = ({ booking }) => {
  return (
    <Wrapper>
      <MobileIcon />

      <HotelInfo name={booking.reservation.property.name} address={booking.reservation.property.formattedAddressFull} />

      <HorizontalRuleDesktop />

      <StayDates checkIn={booking.reservation.checkIn} checkOut={booking.reservation.checkOut} />

      <HorizontalRuleDesktop />

      <OccupantsInfo
        numberOfAdults={booking.reservation.adults}
        numberOfChildren={booking.reservation.children}
        numberOfInfants={booking.reservation.infants}
      />

      <HorizontalRuleDesktop />

      <RoomAndOfferInfo
        roomType={booking.reservation.roomType.name}
        offer={booking.reservation.offer.name}
        isClassicOffer={booking.reservation.offer.type === 'classic'}
      />
    </Wrapper>
  );
};

export default BookingSummary;
